<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <seo-center-card />
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <!--<i class="fab fa-twitter"></i>-->
                <md-icon>today</md-icon>
              </div>
              <p class="category">{{ $t('dashboard.next_session') }}</p>
              <h3 class="title">
                <animated-number
                  :value="notificationsNextSessionBookedCount"
                ></animated-number>
                {{ $t('dashboard.Registered') }}
              </h3>
            </template>

            <template slot="footer">
              <div class="stats">
                {{ $t('dashboard.more_details') }}
                <md-icon>keyboard_arrow_right</md-icon>
              </div>
              <div class="stats pull-right">
                <md-icon>update</md-icon>
                {{ notificationsNextSessionBookedDateTime }}
              </div>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <stats-card header-color="rose">
            <template slot="header">
              <div class="card-icon">
                <md-icon>people</md-icon>
              </div>
              <p class="category">
                {{ $t('dashboard.registered_to_confirm') }}
              </p>
              <h3 class="title">
                <animated-number
                  :value="notificationsBookedToConfirmCount"
                ></animated-number>
                {{ $t('dashboard.registered_waiting') }}
              </h3>
            </template>

            <template slot="footer">
              <div class="stats">
                <md-icon>local_offer</md-icon>
                {{ $t('dashboard.more_details') }}
              </div>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>euro_symbol</md-icon>
              </div>
              <p class="category">{{ $t('dashboard.receipts') }}</p>
              <h3 class="title">
                <animated-number
                  :value="notificationsSessionsToValidateCount"
                ></animated-number>
                {{ $t('dashboard.sessions_to_validate') }}
              </h3>
            </template>

            <template slot="footer">
              <div class="stats">
                <md-icon>keyboard_arrow_right</md-icon>
                <a
                  href="javascript:void(0)"
                  @click="
                    $router.push(localePath('dashboard-listSessionsToValidate'))
                  "
                  >{{
                    $t('dashboard.validate_sessions', {
                      sessionsCount: notificationsSessionsToValidateCount
                    })
                  }}</a
                >
              </div>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <stats-card header-color="blue">
            <template slot="header">
              <div class="card-icon">
                <md-icon>weekend</md-icon>
              </div>
              <p class="category">{{ $t('dashboard.to_accept') }}</p>
              <h3 class="title">
                <animated-number
                  :value="notificationsPlanningsToAcceptCount"
                ></animated-number>
                {{ $t('dashboard.planning') }} <br /><animated-number
                  :value="notificationsSessionsToAcceptCount"
                ></animated-number>
                {{ $t('dashboard.session') }}
              </h3>
            </template>

            <template slot="footer">
              <div class="stats">
                <md-icon class="text-danger">warning</md-icon>
                <a href="#">En cours de développement (lien)...</a>
              </div>
            </template>
          </stats-card>
        </div>
      </div>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <!--    <chart-card
        header-animation="true"
        :chart-data="emailsSubscriptionChart.data"
        :chart-options="emailsSubscriptionChart.options"
        :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
        chart-type="Bar"
        chart-inside-header
        background-color="rose"
      >
        <md-icon slot="fixed-button">build</md-icon>
        <md-button slot="first-button" class="md-simple md-info md-just-icon">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button slot="second-button" class="md-simple md-just-icon">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Website Views</h4>
          <p class="category">
            Last Campaign Performance
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated <animated-number :value="10"></animated-number> days ago
          </div>
        </template>
      </chart-card>-->
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <!--      <chart-card
        :chart-data="dailySalesChart.data"
        :chart-options="dailySalesChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="green"
      >
        <md-button slot="first-button" class="md-simple md-info md-just-icon">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button slot="second-button" class="md-simple md-just-icon">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Daily Sales</h4>
          <p class="category">
            <span class="text-success"
              ><i class="fas fa-long-arrow-alt-up"></i>
              <animated-number :value="55"></animated-number>%
            </span>
            increase in today sales.
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated <animated-number :value="4"></animated-number> minutes ago
          </div>
        </template>
      </chart-card>-->
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <!--      <chart-card
        :chart-data="dataCompletedTasksChart.data"
        :chart-options="dataCompletedTasksChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="blue"
      >
        <md-button slot="first-button" class="md-simple md-info md-just-icon">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button slot="second-button" class="md-simple md-just-icon">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Completed Tasks</h4>
          <p class="category">
            Last Campaign Performance
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            campaign sent
            <animated-number :value="26"></animated-number> minutes ago
          </div>
        </template>
      </chart-card>-->
    </div>
    <!--    <div class="md-layout-item md-size-100">
      <global-sales-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h4 class="title">
            Répartition géographique de la fréquentation de goyoga
          </h4>
        </template>

        <template slot="content">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <global-sales-table></global-sales-table>
            </div>
            <div class="md-layout-item md-size-50">
              <async-world-map class="map" :data="mapData"></async-world-map>
            </div>
          </div>
        </template>
      </global-sales-card>
    </div>-->
    <!--    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <product-card header-animation="true">
        <img slot="imageHeader" class="img" :src="product1" />
        <md-icon slot="fixed-button">build</md-icon>
        <template slot="first-button">
          <md-icon>art_track</md-icon>
          <md-tooltip md-direction="bottom">View</md-tooltip>
        </template>
        <template slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Edit</md-tooltip>
        </template>
        <template slot="third-button">
          <md-icon>close</md-icon>
          <md-tooltip md-direction="bottom">Remove</md-tooltip>
        </template>
        <h4 slot="title" class="title">
          <a href="#pablo">Cozy 5 Stars Apartment</a>
        </h4>
        <div slot="description" class="card-description">
          The place is close to Barceloneta Beach and bus stop just 2 min by
          walk and near to "Naviglio" where you can enjoy the main night life in
          Barcelona.
        </div>
        <template slot="footer">
          <div class="price">
            <h4>$899/night</h4>
          </div>
          <div class="stats">
            <p class="category">
              <md-icon>place</md-icon>
              Barcelona, Spain
            </p>
          </div>
        </template>
      </product-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <product-card header-animation="true">
        <img slot="imageHeader" class="img" :src="product2" />
        <md-icon slot="fixed-button">build</md-icon>
        <template slot="first-button">
          <md-icon>art_track</md-icon>
          <md-tooltip md-direction="bottom">View</md-tooltip>
        </template>
        <template slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Edit</md-tooltip>
        </template>
        <template slot="third-button">
          <md-icon>close</md-icon>
          <md-tooltip md-direction="bottom">Remove</md-tooltip>
        </template>
        <h4 slot="title" class="title">
          <a href="#pablo">Office Studio</a>
        </h4>
        <div slot="description" class="card-description">
          The place is close to Metro Station and bus stop just 2 min by walk
          and near to "Naviglio" where you can enjoy the night life in London,
          UK.
        </div>
        <template slot="footer">
          <div class="price">
            <h4>$1.119/night</h4>
          </div>
          <div class="stats">
            <p class="category">
              <md-icon>place</md-icon>
              London, UK
            </p>
          </div>
        </template>
      </product-card>
    </div>-->
    <!--    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <product-card header-animation="true">
        <img slot="imageHeader" class="img" :src="product3" />
        <md-icon slot="fixed-button">build</md-icon>
        <template slot="first-button">
          <md-icon>art_track</md-icon>
          <md-tooltip md-direction="bottom">View</md-tooltip>
        </template>
        <template slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Edit</md-tooltip>
        </template>
        <template slot="third-button">
          <md-icon>close</md-icon>
          <md-tooltip md-direction="bottom">Remove</md-tooltip>
        </template>
        <h4 slot="title" class="title">
          <a href="#pablo">Beautiful Castle</a>
        </h4>
        <div slot="description" class="card-description">
          The place is close to Metro Station and bus stop just 2 min by walk
          and near to "Naviglio" where you can enjoy the main night life in
          Milan.
        </div>
        <template slot="footer">
          <div class="price">
            <h4>$459/night</h4>
          </div>
          <div class="stats">
            <p class="category">
              <md-icon>place</md-icon>
              Milan, Italy
            </p>
          </div>
        </template>
      </product-card>
    </div>-->
  </div>
</template>

<script>
import Vuex from 'vuex'
import SeoCenterCard from '@/components/admin/dashboard/myActivity/SeoCenterCard'
import {
  StatsCard,
  AnimatedNumber
} from '@/components/creativeTim/dashboardPro/components'

export default {
  components: {
    StatsCard,
    SeoCenterCard,
    AnimatedNumber
  },
  data() {
    return {
      product1: './img/card-2.jpg',
      product2: './img/card-3.jpg',
      product3: './img/card-1.jpg'
    }
  },
  computed: {
    ...Vuex.mapGetters(['loggedInUser']),
    ...Vuex.mapGetters('session', [
      'getCurrentUserSessionsToValidate',
      'getCurrentCenterSessionsToValidate'
    ]),
    notificationsNextSessionBookedCount() {
      return 0
    },
    notificationsPlanningsToAcceptCount() {
      return 0
    },
    notificationsSessionsToAcceptCount() {
      return 0
    },
    notificationsNextSessionBookedDateTime() {
      return 'En cours de développement (date/heure)'
    },
    notificationsBookedToConfirmCount() {
      return 0
    },
    notificationsSessionsToValidateCount() {
      let count = 0
      if (
        this.getCurrentUserSessionsToValidate &&
        this.getCurrentUserSessionsToValidate.count
      ) {
        count += this.getCurrentUserSessionsToValidate.count
      }
      if (
        this.getCurrentCenterSessionsToValidate &&
        this.getCurrentCenterSessionsToValidate.count
      ) {
        count += this.getCurrentCenterSessionsToValidate.count
      }
      return count
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {})
  },
  methods: {}
}
</script>
